export default "__VITE_ASSET__DD56x1pl__"